<div class="forum-create-thread-modal">
  <div class="d-flex flex-row align-items-center gap-12 mb-4">
    <icon-circle
      [name]="modalIconName"
      [set]="modalIconSet"
      [variant]="modalIconVariant"
    />
    <h4 class="flex-grow-1 m-0">{{ modalTitleKey | translate }}</h4>
    <button
      type="button"
      class="forum-create-thread-modal__close"
      aria-label="Close"
      (click)="close()"
    >
      <icon set="lucide" name="x" [size]="24" />
    </button>
  </div>

  <form [formGroup]="form" class="d-flex flex-column gap-4">
    <div *ngIf="!isEditMode && !isStudentMode">
      <p class="text-label mb-2">
        {{ "GROUPS.LIST.CREATE_THREAD_TYPE_LABEL" | translate }}
      </p>
      <select-button
        [options]="threadTypeOptions"
        [selected]="form.controls.type.value"
        [unselectable]="false"
        (optionClickEvent)="selectThreadType($event)"
      />
      <ng-container *ngIf="form.controls.type.value; else threadTypeValidation">
        <p class="text-body-sm color-bg-text-muted mt-2">
          {{
            (form.controls.type.value === ForumThreadType.Announcement
              ? "GROUPS.LIST.THREAD_TYPE_ANNOUNCEMENT_DESCRIPTION"
              : "GROUPS.LIST.THREAD_TYPE_DISCUSSION_DESCRIPTION"
            ) | translate
          }}
        </p>
      </ng-container>
      <ng-template #threadTypeValidation>
        <validation-text textAlign="left" [control]="form.controls.type">
          {{ "GROUPS.LIST.THREAD_TYPE_REQUIRED" | translate }}
        </validation-text>
      </ng-template>
    </div>

    <div>
      <p class="text-label mb-2" for="thread-title">
        {{ "GROUPS.LIST.CREATE_THREAD_SUBJECT_LABEL" | translate }}
      </p>
      <input
        id="thread-title"
        type="text"
        class="w-100"
        formControlName="title"
        [placeholder]="
          'GROUPS.LIST.CREATE_THREAD_SUBJECT_PLACEHOLDER' | translate
        "
      />
      <validation-text textAlign="left" [control]="form.controls.title">
        {{
          form.controls.title.hasError("maxlength")
            ? ("GROUPS.LIST.THREAD_TITLE_MAX_LENGTH" | translate)
            : ("GROUPS.LIST.THREAD_TITLE_REQUIRED" | translate)
        }}
      </validation-text>
    </div>

    <div>
      <p class="text-label mb-2">
        {{ "GROUPS.LIST.CREATE_THREAD_CONTENT_LABEL" | translate }}
      </p>
      <forum-editor
        formControlName="content"
        [members]="data.members"
        [attachmentConfig]="data.attachmentConfig || null"
        [existingAttachments]="isEditMode ? existingAttachments : []"
        (removeExistingAttachment)="removeExistingAttachment($event)"
      />
      <validation-text textAlign="left" [control]="form.controls.content">
        {{ "GROUPS.LIST.THREAD_CONTENT_REQUIRED" | translate }}
      </validation-text>
    </div>

    <div
      *ngIf="
        form.controls.type.value === ForumThreadType.Announcement && !isEditMode
      "
      class="checkbox-wrapper"
    >
      <input
        type="checkbox"
        class="checkbox"
        formControlName="send_announcement_email"
        id="send_announcement_email"
      />
      <label class="checkbox" for="send_announcement_email">
        {{
          "GROUPS.LIST.CREATE_THREAD_SEND_ANNOUNCEMENT_EMAIL_LABEL" | translate
        }}
      </label>
    </div>
  </form>

  <div class="d-flex justify-content-end mt-4">
    <button
      type="button"
      class="btn-primary"
      [disabled]="form.invalid"
      (click)="submit()"
    >
      {{ submitButtonKey | translate }}
    </button>
  </div>
</div>
